import type { IconSvgObject } from './types';

const ExclamationMarkBigIcon: IconSvgObject = [
  ["path", { d: "M13.5 13V5C13.5 4.44772 13.0523 4 12.5 4H11.5C10.9477 4 10.5 4.44772 10.5 5V13C10.5 13.5523 10.9477 14 11.5 14H12.5C13.0523 14 13.5 13.5523 13.5 13Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 20C12.8284 20 13.5 19.3284 13.5 18.5C13.5 17.6716 12.8284 17 12 17C11.1716 17 10.5 17.6716 10.5 18.5C10.5 19.3284 11.1716 20 12 20Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ExclamationMarkBigIcon;
